<!-- BEGIN #sidebar -->
<div id="sidebar" class="app-sidebar" [attr.data-bs-theme]="appSettings.appSidebarLight ? '' : 'dark'"
	[ngClass]="{ 
	'app-sidebar-transparent': this.appSidebarTransparent,
	'app-sidebar-grid': this.appSidebarGrid
}">
  <!-- BEGIN scrollbar -->
  <ng-scrollbar class="app-sidebar-content prodynamics-scroll"   [ngClass]="{
    'h-75': appSettings.appSidebarMinified,
    'h-80': appSettings.appSidebarFixed && !appSettings.appSidebarMinified
  }" #sidebarScrollbar (scroll)="onScroll($event)">
    <ng-container *ngTemplateOutlet="sidebarNav"></ng-container>
  </ng-scrollbar >
  <!-- END scrollbar -->

  <ng-template #sidebarNav>
  	<!-- BEGIN menu -->
		<div class="menu">
			<div class="menu-item menu-profile" *ngIf="!appSettings.appSidebarSearch">
				<a href="javascript:;" class="menu-profile-link" (click)="toggleNavProfile($event)">
					<div class="menu-profile-cover with-shadow"></div>
					<div class="menu-profile-logo">
            <img src="../../../assets/img/cover-sidebar.png">
          </div>
					<div class="menu-profile-info">
						<div class="d-flex align-items-center">
							<div class="flex-grow-1">
								{{getUser()}}
							</div>
							<!-- <div class="menu-caret ms-auto"></div> -->
						</div>
            <div class="d-flex align-items-center">
              <small>{{getVariableSesion('profile')}}</small>
              <i *ngIf="cambiarRol()" (click)="cambiarPerfil()" class="fa-solid fa-pen-to-square ms-2 text-gray"></i>
            </div>
					</div>
				</a>
			</div>
			
			<div class="menu-search mb-n3" *ngIf="appSettings.appSidebarSearch">
        <input type="text" class="form-control" placeholder="Sidebar menu filter..." (keyup)="appSidebarSearch($event)" />
      </div>
      <div class="menu-header">Menú</div>

      <!-- render sidebarMenuNav -->
      <ng-template #sidebarMenuNav let-menu="menu">
        <div class="menu-icon-img" *ngIf="menu?.img"><img src="{{ menu?.img }}" /></div>
        <div class="menu-icon" *ngIf="menu?.icon"><i class="{{ menu?.icon }}"></i></div>
        <div class="menu-text" *ngIf="menu?.title">
          {{ menu?.title }}
          <span class="menu-label" *ngIf="menu?.label">{{ menu?.label }}</span>
        </div>
        <div class="menu-badge" *ngIf="menu?.badge">{{ menu?.badge }}</div>
        <div class="menu-caret" *ngIf="menu?.caret"></div>
      </ng-template>

      <!-- render sidebarSubMenuNav -->
      <ng-template #sidebarSubMenuNav let-menu="menu">
        <div class="menu-text" *ngIf="menu?.title">
        	{{ menu.title }}
        	<i class="fa fa-paper-plane text-theme ms-5px" *ngIf="menu?.highlight"></i>
        </div>
        <div class="menu-caret" *ngIf="menu?.caret"></div>
      </ng-template>

      <!-- sidebar menu -->
      <div class="menu-item" *ngFor="let menu of menus" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [ngClass]="{ 'expand': menu?.state == 'expand', 'has-sub': menu?.submenu, 'd-none': menu?.hide }" #rla="routerLinkActive">
        <a class="menu-link c-pointer" [title]="menu?.title" *ngIf="menu?.submenu" (mouseenter)="showAppSidebarFloatSubMenu(menu?.submenu, $event)" (mouseleave)="hideAppSidebarFloatSubMenu()">
          <ng-container *ngTemplateOutlet="sidebarMenuNav; context: {menu: menu}"></ng-container>
        </a>
        <a class="menu-link" [title]="menu?.title" *ngIf="!menu?.submenu" (click)="irA()" [routerLink]="menu?.url">
          <ng-container *ngTemplateOutlet="sidebarMenuNav; context: {menu: menu}"></ng-container>
        </a>

        <!-- submenu lvl 1 -->
        <div class="menu-submenu" *ngIf="menu?.submenu" [style.display]="(menu?.state == 'expand' && !appSettings.appSidebarMinified) ? 'block' : (menu?.state == 'collapse') ? 'none' : ''">
          <div class="menu-item" *ngFor="let menu1 of menu?.submenu" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [ngClass]="{ 'expand': menu1?.state == 'expand', 'closed': menu1?.state == 'collapsed', 'has-sub': menu1?.submenu, 'd-none': menu1?.hide }" #rla1="routerLinkActive">
            <a class="menu-link" [title]="menu1?.title" *ngIf="menu1?.submenu" (click)="(menu1?.submenu) ? expandCollapseSubmenu(menu1, menu?.submenu, rla1) : ''">
              <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu1}"></ng-template>
            </a>
            <a class="menu-link" [title]="menu1?.title" *ngIf="!menu1?.submenu" (click)="irA()" [routerLink]="menu1?.url">
              <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu1}"></ng-template>
            </a>

            <!-- submenu lvl 2 -->
            <div class="menu-submenu" *ngIf="menu1.submenu" [style.display]="(menu1.state == 'expand' && !appSettings.appSidebarMinified) ? 'block' : (menu1.state == 'collapse') ? 'none' : ''">
              <div class="menu-item" *ngFor="let menu2 of menu1.submenu" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [ngClass]="{ 'expand': menu2.state == 'expand', 'closed': menu2.state == 'collapsed', 'has-sub': menu2.submenu, 'd-none': menu2.hide }" #rla2="routerLinkActive">
                <a class="menu-link" *ngIf="menu2.submenu" (click)="(menu2.submenu) ? expandCollapseSubmenu(menu2, menu1.submenu, rla2) : ''">
                  <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu2}"></ng-template>
                </a>
                <a class="menu-link" *ngIf="!menu2.submenu" (click)="irA()" [routerLink]="menu2.url">
                  <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu2}"></ng-template>
                </a>

                <!-- submenu lvl 3 -->
                <div class="menu-submenu" *ngIf="menu2.submenu" [style.display]="(menu2.state == 'expand' && !appSettings.appSidebarMinified) ? 'block' : (menu2.state == 'collapse') ? 'none' : ''">
                  <div class="menu-item" *ngFor="let menu3 of menu2.submenu" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [ngClass]="{ 'expand': menu3.state == 'expand', 'closed': menu3.state == 'collapsed', 'has-sub': menu3.submenu, 'd-none': menu3.hide }" #rla3="routerLinkActive">
                    <a class="menu-link" *ngIf="menu3.submenu" (click)="(menu3.submenu) ? expandCollapseSubmenu(menu3, menu2.submenu, rla3) : ''">
                      <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu3}"></ng-template>
                    </a>
                    <a class="menu-link" *ngIf="!menu3.submenu" (click)="irA()" [routerLink]="menu3.url">
                      <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu3}"></ng-template>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="menu-item">
        <a style="cursor: pointer;" (click)="logout()" class="menu-link c-pointer">
          <div class="menu-icon" title="Cerrar sesión">
            <i class="fa-solid fa-power-off"></i>
          </div>
          <div class="menu-text">  Cerrar sesión</div>          
        </a>
      </div>

      
			
			<!-- BEGIN minify-button -->
			<div class="menu-item d-flex">
				<a href="javascript:;" class="app-sidebar-minify-btn ms-auto" (click)="toggleAppSidebarMinified()"><i class="fa fa-angle-double-left"></i></a>
			</div>
			<!-- END minify-button -->
    </div>
    
    <!-- END menu -->
  </ng-template>
  <div class="d-flex flex-column justify-content-center align-items-center" id="footer">
    <span class="text-white text-center" [ngClass]="{ 'sidebar-deactivated-text': appSettings.appSidebarMinified }">v1.0</span>
    <span class="text-white text-center" [ngClass]="{ 'sidebar-deactivated-text': appSettings.appSidebarMinified }">Tires & Wheels Expenses</span>
    <p class="text-white text-center" [ngClass]="{ 'sidebar-deactivated-text': appSettings.appSidebarMinified }" style="margin: 8px;">Powered by</p>
    <img src="../assets/img/prodx-logo-1x.png" style="max-width: 120px; width: 100%; height: auto;padding: 7px;" alt="">
  </div>
</div>
<div class="app-sidebar-bg" [attr.data-bs-theme]="appSettings.appSidebarLight ? '' : 'dark'"></div>
<div class="app-sidebar-mobile-backdrop"><a href="javascript:;" (click)="toggleAppSidebarMobile()" class="stretched-link"></a></div>
		
<!-- END #sidebar -->

<float-sub-menu *ngIf="appSettings.appSidebarMinified"
  [menus]="appSidebarFloatSubMenu"
  [top]="appSidebarFloatSubMenuTop"
  [left]="appSidebarFloatSubMenuLeft"
  [right]="appSidebarFloatSubMenuRight"
  [bottom]="appSidebarFloatSubMenuBottom"
  [arrowTop]="appSidebarFloatSubMenuArrowTop"
  [arrowBottom]="appSidebarFloatSubMenuArrowBottom"
  [lineTop]="appSidebarFloatSubMenuLineTop"
  [lineBottom]="appSidebarFloatSubMenuLineBottom"
  (remainAppSidebarFloatSubMenu)="remainAppSidebarFloatSubMenu()"
  (hideAppSidebarFloatSubMenu)="hideAppSidebarFloatSubMenu()"
  (calculateAppSidebarFloatSubMenuPosition)="calculateAppSidebarFloatSubMenuPosition()"
></float-sub-menu>
